import { Controller } from "@hotwired/stimulus"

// Handles status change on the status badge <select>.
// If status=accepted and pitch is from general pool, the select
// still submits — the accept modal on the show page handles assignment.
export default class extends Controller {
  static values = { submissionId: Number, general: Boolean }

  change(event) {
    const newStatus = event.target.value
    const submissionId = this.submissionIdValue
    const token = document.querySelector("meta[name='csrf-token']")?.content

    fetch(`/partners/pitches/${submissionId}/update_status`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token,
        "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml"
      },
      body: `status=${encodeURIComponent(newStatus)}`
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      }
      throw new Error("Failed to update status")
    })
    .then(html => {
      // Turbo will handle the turbo-stream response automatically
      // if the content type is correct. For non-turbo responses,
      // reload the element.
      if (html.includes("turbo-stream")) {
        document.documentElement.innerHTML = document.documentElement.innerHTML
        Turbo.renderStreamMessage(html)
      }
    })
    .catch(error => {
      console.error("Status update failed:", error)
      // Revert the select to the original value
      event.target.value = event.target.dataset.originalValue || event.target.options[0].value
    })
  }

  // Store original value when the select gets focus
  selectTargetConnected(element) {
    element.dataset.originalValue = element.value
    element.addEventListener("focus", () => {
      element.dataset.originalValue = element.value
    })
  }
}
